var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticClass:"table",attrs:{"size":"mini","data":_vm.data,"border":""}},_vm._l((_vm.columns),function(h,idx){return _c('el-table-column',{key:idx,attrs:{"prop":`month-${idx === 0 ? 'header' : idx}`,"label":h,"min-width":_vm.$lange == 'en' ? 100:60,"show-overflow-tooltip":""}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }